import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'pivot-confirm-dialog',
  templateUrl: './pivot-confirm-dialog.component.html',
  styleUrls: ['./pivot-confirm-dialog.component.scss'],
})
export class PivotConfirmDialogComponent implements OnInit {
  title = '';
  message = '';
  confirmButtonText = '';
  cancelButtonText = '';
  /**
   * 0: notification dialog
   * 1: confirm dialog
   */
  type = 0;
  messageLeft = false;
  useInnerHTML = false;
  isDisplayHeader = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    public dialogRef: MatDialogRef<PivotConfirmDialogComponent>,
  ) {
    if (this.data) {
      this.title = this.data.title;
      this.message = this.data.message;
      this.confirmButtonText = this.data.confirmButtonText || 'OK';
      this.type = this.data.type || 0;
      if (this.type) {
        this.cancelButtonText = 'BUTTON.CANCEL';
      } else {
        this.cancelButtonText = 'BUTTON.CLOSE';
      }
      this.messageLeft = this.data.messageLeft || false;
      this.useInnerHTML = this.data.useInnerHTML || false;
      this.isDisplayHeader = this.data.hasOwnProperty('isDisplayHeader') ? this.data.isDisplayHeader : true;
    }
  }

  ngOnInit() {
    //
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onDismiss(): void {
    this.dialogRef.close(false);
  }
}
